import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormHelperText } from '@mui/material'
import CustomInput from './styled/CustomInput.styled'
import '../styles/Modal.scss'
import StylistModal from './StylistModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#08C4BB',
    },
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background:
            'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%) 0% 0% no-repeat padding-box',
          borderRadius: '10px',
          opacity: 1,
          height: '48px',
          color: '#fff',
          textTransform: 'capitalize',
        },
        '&:hover': {
          // backgroundColor: '#000'
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'primary',
          borderRadius: '16px',
          '&.Mui-checked': {
            color: '#2597F6',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          border: '1px solid #fff',
          borderRadius: '16px',
          boxShadow: '0px 5px 20px #00000040',
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
})

const AddressModal = ({ toggleAddressModal, modalOpen = false }) => {
  const [chooseStylist, setChooseStylist] = React.useState(false)
  const toggleStylistModal = (toggleModal) => {
    setChooseStylist(toggleModal)
  }
  return (
    <ThemeProvider theme={theme}>
      {/* <div> */}
      <>
        <Modal
          open={modalOpen}
          onClose={() => toggleAddressModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="modal-width">
            {/* <Container> */}
            <h3>Address</h3>
            <div className="maps-wrapper h-25"></div>
            <div className="location-input">
              <FormHelperText id="input-label" margin="dense">
                Location
              </FormHelperText>
              <CustomInput
                margin="dense"
                id="email"
                fullWidth={true}
                type="email"
              />
            </div>
            <hr />
            <div className="text-left">
              <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
                Estimated size of your style?
              </p>
            </div>
            <div className="size mb-3 d-flex justify-content-between align-content-center">
              <button className="size-button">Small</button>
              <button className="size-button">Medium</button>
              <button className="size-button">Large</button>
            </div>
            <Button
              disableElevation
              variant="contained"
              className="mt-4"
              fullWidth={true}
              onClick={() => toggleStylistModal(true)}
            >
              Continue
            </Button>
            {/* </Container> */}
          </Box>
        </Modal>
        <StylistModal
          toggleStylistModal={toggleStylistModal}
          modalOpen={chooseStylist}
        />
      </>
      {/* </div> */}
    </ThemeProvider>
  )
}

export default AddressModal
